module.exports = __webpack_public_path__ + "static/media/nippon.8dfcb51b.svg";